<script>
import ApprovalSheetName from './ApprovalSheetName.vue'
import CodificationSeparatorSelect from './CodificationSeparatorSelect.vue'

export default {
  name: 'CodificationSection',
  components: {
    ApprovalSheetName,
    CodificationSeparatorSelect,
  },
  props: {
    unicityList: {
      type: Array,
      required: true,
    },
    codificationList: {
      type: Array,
      required: true,
    },
    indexList: {
      type: Array,
      required: true,
    },
    titleList: {
      type: Array,
      required: true,
    },
    activeMetadata: {
      type: Array,
      required: true,
    },
    separatorProp: {
      type: String,
      required: true,
    },
    approvalSheetSuffix: {
      type: String,
      required: true,
    },
    approvalSheetPrefix: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: true,
    },
  },
  emits: [
    'update:modelValue',
    'changeSeparator',
    'changeApprovalSheetSuffix',
    'changeApprovalSheetPrefix',
  ],
  data () {
    return {
      separator: this.separatorProp,
      unicityListData: {},
      codificationListData: {},
      indexListData: {},
      titleListData: {},
    }
  },
  watch: {
    unicityList: {
      handler() {
        this.unicityListData = this.unicityList
      },
      immediate: true,
    },
    codificationList: {
      handler() {
        this.codificationListData = this.codificationList
      },
      immediate: true,
    },
    indexList: {
      handler() {
        this.indexListData = this.indexList
      },
      immediate: true,
    },
    titleList: {
      handler() {
        this.titleListData = this.titleList
      },
      immediate: true,
    },
  },
  methods: {
    isValidIndex (index) {
      if (index) {
        const unicityCheck = this.unicityList.filter(o => index.includes(o))
        const codificationCheck = this.codificationList.filter(o => index.includes(o))
        return (!unicityCheck.length && !codificationCheck.length)
          || this.$gettext('A metadatum used in the index is also in the unicity or the codification')
      } else {
        return true
      }
    },
    onChangeApprovalSheetSuffix (suffix) {
      this.$emit('changeApprovalSheetSuffix', suffix)
    },
    onChangeApprovalSheetPrefix (prefix) {
      this.$emit('changeApprovalSheetPrefix', prefix)
    },
    getNameFromItem (item) {
      return item.name
    },
    onChangeSeparator (separator) {
      this.separator = separator
      this.$emit('changeSeparator', this.separator)
    },
    onUpdateModelValue (newValue, list) {
      this.$emit('update:modelValue', newValue, list)
    },
  },
}
</script>
<template>
  <div class="form-section">
    <h1>{{ $gettext('Codification') }}</h1>
    <v-card>
      <v-card-text>
        <CodificationSeparatorSelect
          v-model:current-separator="separator"
          :disabled="disabled"
          @update-current-separator="onChangeSeparator"
        />
        <ChipsAutocomplete
          v-model="unicityListData"
          :label="$gettext('Fields making up the documents\' unicity (order counts)')"
          item-value="name"
          :item-display="getNameFromItem"
          :items="activeMetadata"
          :disabled="disabled"
          :prepend-inner-text="$gettext('Contract')"
          @update:model-value="newValue => onUpdateModelValue(newValue, 'unicityList')"
        />
        <ChipsAutocomplete
          v-model="codificationListData"
          :label="$gettext('Fields making up the codification (order counts)')"
          item-value="name"
          :item-display="getNameFromItem"
          :items="activeMetadata"
          :disabled="disabled"
          @update:model-value="newValue => onUpdateModelValue(newValue, 'codificationList')"
        />
        <ChipsAutocomplete
          v-model="indexListData"
          :label="$gettext('Fields making up the index (order counts)')"
          item-value="name"
          :item-display="getNameFromItem"
          :items="activeMetadata"
          :disabled="disabled"
          :rules="[isValidIndex]"
          @update:model-value="newValue => onUpdateModelValue(newValue, 'indexList')"
        />
        <ChipsAutocomplete
          v-model="titleListData"
          :label="$gettext('Fields making up the title (order counts)')"
          item-value="name"
          :items="activeMetadata"
          :item-display="getNameFromItem"
          :disabled="disabled"
          @update:model-value="newValue => onUpdateModelValue(newValue, 'titleList')"
        />
      </v-card-text>
    </v-card>
    <ApprovalSheetName
      :approval-sheet-prefix="approvalSheetPrefix"
      :approval-sheet-suffix="approvalSheetSuffix"
      @change-approval-sheet-prefix="onChangeApprovalSheetPrefix"
      @change-approval-sheet-suffix="onChangeApprovalSheetSuffix"
    />
  </div>
</template>
